import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col, Alert } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import Clock from 'react-live-clock'
import moment from 'moment'
import Webcam from 'react-webcam'

import VisitorCount from './components/visitorCount'
import VisitorGraph from './components/visitorGraph'
import Events from './components/events'
import OfficerAvatar from '../../../components/Custom/UserAvatar'

const videoConstraints = {
	width: 720,
	height: 720,
	facingMode: 'user'
}

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			previewImage: null
		}

		this.webcamRef = React.createRef()

		this.handleGetScreenshot = this.handleGetScreenshot.bind(this)
	}

	componentDidMount() {
		this.props.subscribeToNewLogs()
	}

	async handleGetScreenshot (scannedData) {
		const { saveDTRPhoto } = this.props
		const imageSrc = this.webcamRef.current.getScreenshot()

		const fileObject = await handleImageBase64ToFileObject(imageSrc)
		const fileList = []
		fileList.push({ originFileObj: fileObject })

		const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
		const files = []
		if (formattedFiles.length > 0) {
			files.push(formattedFiles[formattedFiles.length - 1])
		}

		const params = {
			dtr_uid: scannedData.dtrUID,
			log_status: scannedData.logStatus,
			files
		}
		saveDTRPhoto(params)
	}

 	render() {
 		const { dashboardData, scannedData, error } = this.props
		//  console.log('dashboardData', dashboardData)
		//  console.log('scannedData', scannedData)

		if (_.has(scannedData, 'user_type') && _.isEqual(scannedData.user_type, 'EMPLOYEE')) {
			this.handleGetScreenshot(scannedData)
		}

 		return (
 			<React.Fragment>
 				<Row style={{ padding: 20 }} gutter={24}>
 					<Col md={12} sm={24}>
 						<Row gutter={16}>
 							<Col md={18} sm={24}>
 								<Row className='dtr-dashboard-box-panel' style={{ textAlign: 'center' }}>
 									<span style={{ fontSize: '48px' }}>
 										{moment().format('ddd')}, {moment().format('ll')} &nbsp;&nbsp;
 										<Clock 
 											format={'h:mm:ss A'} 
 											ticking={true} 
 											timezone={'Asia/Manila'}
 										/>
 									</span><br/>

 									<Row style={{ marginTop: 30 }}>
 										<Col md={12} sm={24}>
 											<OfficerAvatar 
 												size={150}
 												user_uid={_.has(scannedData, 'uid') ? scannedData.uid : null}
 											/>
 										</Col>
 										<Col md={12} sm={24}>
 											<Webcam
 												audio={false}
 												height={150}
 												ref={this.webcamRef}
 												screenshotFormat="image/jpeg"
 												width={150}
 												videoConstraints={videoConstraints}
 											/>
 										</Col>
 									</Row>
 									<Row style={{ marginTop: 30 }}>
 										<h1>{_.has(scannedData, 'full_name') ? scannedData.full_name : 'Ready to Scan'}</h1>
 									</Row>
 									<Row>
 										<i style={{ color: 'blue' }}>Press F2 for manual log</i>
 									</Row>
 									{
 										scannedData &&
										<div style={{ marginTop: 10 }} className="alert alert-icon alert-warning alert-dismissible fade show" role="alert">
											<i className="mdi mdi-alert mr-2"></i>
											Welcome, You have successfully {_.has(scannedData, 'logStatus') ? scannedData.logStatus : 'logged in'} the system
										</div>
 									}
 									{
 										error &&
										<div style={{ marginTop: 20 }} className="alert alert-icon alert-danger alert-dismissible fade show" role="alert">
											<i className="mdi mdi-alert mr-2"></i>
											{error.message.replace('GraphQL error:','')}
										</div>
 									}
 								</Row>
 							</Col>
 							<Col md={6} sm={24}>
 								<VisitorCount dashboardData={dashboardData} />
 							</Col>
 						</Row>
 						<Row className='dtr-dashboard-box-panel' style={{ marginTop: 10 }}>
 							<VisitorGraph dashboardData={dashboardData} />
 						</Row>
 					</Col>
 					{/* <Col md={12} sm={24}>
						<Row className='dtr-dashboard-box-panel' gutter={16} style={{ textAlign: 'center' }}>
							<Col md={24} sm={24}>
								<video style={{ width: '100%', height: 'auto' }} autoPlay controls loop muted>
									<source src="/assets/videos/covid-video.mp4" type="video/mp4" />
								</video>
							</Col>
						</Row>
						<Row className='dtr-dashboard-box-panel' gutter={16} style={{ marginTop: 15, textAlign: 'center', height: 415, maxHeight: 415 }}>
							<Col md={24} sm={24}>
								<Events dashboardData={dashboardData} />
							</Col>
						</Row>
					</Col> */}
 					<Col md={12} sm={24}>
 						<Row className='dtr-dashboard-box-panel' gutter={16} style={{ textAlign: 'center' }}>
 							<Col md={24} sm={24}>
 								<Events dashboardData={dashboardData} />
 							</Col>
 						</Row>
 					</Col>
 				</Row>
 			</React.Fragment>
 		)
 	}
}

const handleImageBase64ToFileObject = (imageBase64) => {
	return new Promise((resolve, reject) => {
		const filename = `${moment().format('YYYYMMDDHHmmss')}_photoFromCamera.png`
		const bstr = window.atob(imageBase64.split(',')[1])
		let n = imageBase64.length
		const u8arr = new Uint8Array(n)
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n)
		}
		const file = new File([u8arr], filename, { type: 'image/png' })
		resolve(file)
	})
}

const SAVE_DTR_PHOTOS = gql`
    mutation saveDTRPhotos($input: JSON) {
		saveDTRPhotos(input: $input)
    }
`

const composed = compose(
	graphql(SAVE_DTR_PHOTOS, {
		props({ mutate }) {
			return {
				saveDTRPhoto(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['generalSettings']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
